// extracted by mini-css-extract-plugin
export var md = "_2c-4";
export var semantic = "_2c-5";
export var sm = "_2c-3";
export var text = "_2c-6";
export var toggleInput = "_2c-0";
export var toggleSwitch = "_2c-1";
export var xs = "_2c-2";